import PropTypes from 'prop-types';
import React from 'react';
import {
  Fab,
  Paper,
} from '@material-ui/core';

const labelPadding = 4;

const rootStyle = size => ({
  height: size,
  position: 'relative',
  display: 'inline-block',
  pointerEvents: 'none',
});

const buttonWrapperStyle = (size, direction) => ({
  position: 'absolute',
  left: direction === 'left' ? 0 : 'auto',
  right: direction === 'right' ? 0 : 'auto',
  pointerEvents: 'auto',
});

const labelWrapperStyle = (size, direction) => ({
  cursor: 'default',
  display: 'inline-block',
  height: size + 2 * labelPadding,
  marginTop: -labelPadding,
  marginRight: direction === 'right' ? size / 2 : 0,
  marginBottom: 0,
  marginLeft: direction === 'left' ? size / 2 : 0,
  overflow: 'hidden',
  paddingTop: labelPadding,
  paddingRight: direction === 'right' ? 0 : labelPadding,
  paddingBottom: labelPadding + 1,
  paddingLeft: direction === 'left' ? 0 : labelPadding,
});

const labelStyle = (size, backgroundColor, color, direction, open) => ({
  backgroundColor,
  color,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  paddingTop: 0,
  paddingRight: direction === 'right' ? 10 + size / 2 : 14,
  paddingBottom: 0,
  paddingLeft: direction === 'left' ? 10 + size / 2 : 14,
  transition: 'all 0.3s ease',
  whiteSpace: 'nowrap',
  margin: (
    !open && direction === 'left' && '0 100% 0 -100%' ||
    !open && direction === 'right' && '0 0 0 100%' ||
    0
  ),
  pointerEvents: 'auto',
});

const LabeledActionButton = (
  {
    buttonBackgroundColor,
    children,
    direction = 'left',
    label,
    labelBackgroundColor = '#fff',
    labelColor = '#000',
    mini = false,
    onClick,
    open = false,
  },
) => {
  const size = mini ? 40 : 56;
  return (
    <div style={rootStyle(size)}>
      <div style={buttonWrapperStyle(size, direction)}>
        <Fab
          style={{backgroundColor: buttonBackgroundColor, height: '40px', width: '40px'}}
          onClick={onClick}
        >
          {children}
        </Fab>
      </div>
      <div style={labelWrapperStyle(size, direction)}>
        <Paper style={labelStyle(size, labelBackgroundColor, labelColor, direction, open)}>
          {label}
        </Paper>
      </div>
    </div>
  );
};

LabeledActionButton.propTypes = {
  buttonBackgroundColor: PropTypes.string,
  children: PropTypes.node,
  direction: PropTypes.oneOf(['left', 'right']),
  label: PropTypes.node,
  labelBackgroundColor: PropTypes.string,
  labelColor: PropTypes.string,
  mini: PropTypes.bool,
  onClick: PropTypes.func,
  open: PropTypes.bool,
};

export default LabeledActionButton;



// WEBPACK FOOTER //
// ./src/ondemand/components/LabeledActionButton/LabeledActionButton.js